module.exports = __webpack_public_path__ + "img/xxtz.79edf577.png";